import {ApiClient} from '@hconnect/apiclient'
import {FeatureTranslationsLoader} from '@hconnect/common/localization-loaders'
import {hpTheme} from '@hconnect/uikit'
import {UpmPlantsProvider} from '@hconnect/upm'
import {useSuiteHierarchyId} from '@hproduce/suite-core'
import {CircularProgress, ThemeProvider} from '@mui/material'
import {LocalizationProvider} from '@mui/x-date-pickers'
import {AdapterMoment} from '@mui/x-date-pickers/AdapterMoment'
import {Suspense} from 'react'
import {Navigate, Outlet, RouteObject} from 'react-router'

import {
  AnalysisDetailPage,
  AnalysisListPage,
  CreateAnalysisPage,
  PlantUpmIdAdapter
} from '../components'
import {rcfaListFeatureTranslations} from '../localization'

import {RcfaBaseRoutes} from './routes'

const RoutesWrapper = ({children}: {children: React.ReactNode}) => {
  const plantUpmId = useSuiteHierarchyId()

  if (!plantUpmId) {
    throw new Error('Hierarchy id is required in RcfaListRoutes')
  }

  return (
    <ThemeProvider theme={hpTheme}>
      <Suspense fallback={<CircularProgress color="secondary" size={80} />}>
        <LocalizationProvider dateAdapter={AdapterMoment}>
          <UpmPlantsProvider api={ApiClient.axiosInstance}>
            <PlantUpmIdAdapter plantUpmId={plantUpmId}>{children}</PlantUpmIdAdapter>
          </UpmPlantsProvider>
        </LocalizationProvider>
      </Suspense>
    </ThemeProvider>
  )
}

export const rcfaListRoutes: RouteObject = {
  path: '*',
  element: (
    <FeatureTranslationsLoader translations={rcfaListFeatureTranslations}>
      <RoutesWrapper>
        <Outlet />
      </RoutesWrapper>
    </FeatureTranslationsLoader>
  ),
  children: [
    {
      index: true,
      element: <Navigate to={RcfaBaseRoutes.analysisList} replace />
    },
    {
      path: RcfaBaseRoutes.analysisList,
      element: <AnalysisListPage />
    },
    {
      path: RcfaBaseRoutes.graphDetail,
      element: <AnalysisDetailPage />
    },
    {
      path: RcfaBaseRoutes.newAnalysis,
      element: <CreateAnalysisPage />
    },
    {path: '*', element: <Navigate to="/404" replace />}
  ]
}
